'use client';

import React from "react";
import { initialsOf, formatPhone } from "../internals";
import { RoleChip } from "./RoleChip";
import { StatusBadge } from "./StatusBadge";

// One member row in the list. Whole row is a button so the tap
// target is generous. Onclick is wired in M3 to open the edit
// drawer; in M2 it's a no-op.
export const MemberRow = ({ member, onClick }) => (
  <button
    type="button"
    data-testid={`member-row-${member.id}`}
    onClick={onClick || (() => {})}
    className="flex w-full items-center gap-3 rounded-lg border border-zinc-200 bg-white px-3 py-3 text-left transition-colors hover:bg-zinc-50"
  >
    <span
      aria-hidden="true"
      className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-rose-100 text-sm font-semibold text-rose-700"
    >
      {initialsOf(member.name)}
    </span>
    <span className="min-w-0 flex-1">
      <span className="block truncate text-sm font-semibold text-zinc-900">
        {member.name || "—"}
      </span>
      <span className="block truncate text-xs text-zinc-500">
        {member.designation ? `${member.designation} · ` : ""}
        {formatPhone(member.phone)}
      </span>
    </span>
    <span className="flex shrink-0 items-center gap-2">
      <RoleChip role={member.role} />
      {member.status && member.status !== "active" && <StatusBadge status={member.status} />}
    </span>
  </button>
);
